// extracted by mini-css-extract-plugin
module.exports = {"page":"RecomendationEngine_page__2QE2G","form":"RecomendationEngine_form__iPQOV"};